var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWeNeedYourHelpText(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 7434.743,
    height: 4997.031,
    viewBox: "0 0 7434.743 4997.031",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1279",
    "data-name": "Group 1279",
    transform: "translate(-8116.576 17699.49)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_441",
    "data-name": "Ellipse 441",
    cx: 342,
    cy: 342,
    r: 342,
    transform: "translate(8524 -17240)",
    fill: "#0e7f8a",
    opacity: 0.095
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_442",
    "data-name": "Ellipse 442",
    cx: 150,
    cy: 150,
    r: 150,
    transform: "translate(8995 -16368)",
    fill: "#0e7f8a",
    opacity: 0.095
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_443",
    "data-name": "Ellipse 443",
    transform: "translate(13516 -14092.927)",
    fill: "none",
    stroke: "#397d88",
    strokeWidth: 20,
    strokeDasharray: 20,
    opacity: 0.395
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 494,
    r: 494,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 494,
    cy: 494,
    r: 484,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path14",
    d: "M0,4397.034H7434.743V-600H0Z",
    transform: "translate(8116.576 -17099.492)",
    fill: "#b0cfcc",
    opacity: 0
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeNeedYourHelpText);
export default __webpack_public_path__ + "static/media/weNeedYourHelpText.9b79bc477b7481e42aa19cefcd17c943.svg";
export { ForwardRef as ReactComponent };